/** App-wide default when no currency is stored on the user, pool, or record. */
export const DEFAULT_CURRENCY = "GBP";
